export const DIALOG_WIDTH = 870;

export const MUI_DIALOG_MAX_HEIGHT = 'calc(100vh - 128px)';
export const MUI_DIALOG_MAX_HEIGHT_MINUS = (pixels) => {return 'calc(100vh - ' + (pixels + 128) + 'px)';};

export const TITLE_HEIGHT = 45;
export const CONTENT_HEIGHT = 500;
export const BUTTONS_SECTION_HEIGHT = 80;
export const CONTENT_MAX_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT);

export const DIALOG_HEIGHT = TITLE_HEIGHT + CONTENT_HEIGHT + BUTTONS_SECTION_HEIGHT;
